export default __webpack_public_path__ + "static/media/pa.f06ec28a.svg";